export const CLAIM_CATEGORIES = [
  "Liability",
  "Engineering",
  "Banks & Financial Institutions",
  "Property & Business Interruption",
  "Marine",
  "Employee Benefits",
  "Film & Entertainment",
  "Other / Not sure",
];

export const CLAIM_CHECKLISTS = {
  "Liability": [
    "Copy of the policy",
    "Claim intimation letter describing the incident",
    "Legal notice / court summons received (if any)",
    "Photographs of the site, damage or injury",
    "Details of the third party and witnesses",
    "Medical reports / repair estimates (as applicable)",
  ],
  "Engineering": [
    "Copy of the policy",
    "FIR (in case of theft, burglary or third-party damage)",
    "Photographs of the damaged works / machinery",
    "Project contract and work-order details",
    "Repair or replacement estimates from the OEM / contractor",
    "Maintenance and inspection records",
  ],
  "Banks & Financial Institutions": [
    "Copy of the policy",
    "FIR / internal investigation report",
    "Statement of account or transaction records",
    "Details of employees / persons involved (for fidelity claims)",
    "Photographs and CCTV footage (if available)",
    "Board resolution authorising the claim (for institutions)",
  ],
  "Property & Business Interruption": [
    "Copy of the policy",
    "Fire brigade report (for fire claims)",
    "Photographs of damaged property and stock",
    "Stock records, purchase and sales registers",
    "Repair / reinstatement estimates",
    "Financial statements (for business interruption claims)",
  ],
  "Marine": [
    "Copy of the policy / certificate",
    "Invoice, packing list and lorry receipt / bill of lading",
    "Photographs of damaged cargo and packing",
    "Carrier's remark / damage certificate",
    "Survey report (arranged via insurer)",
    "Claim bill with repair or replacement value",
  ],
  "Employee Benefits": [
    "Copy of the policy / member details",
    "Hospital discharge summary and bills (mediclaim)",
    "FIR / post-mortem report (accident claims)",
    "Medical certificates and diagnostic reports",
    "KYC of employee / nominee",
    "Employer's confirmation letter",
  ],
  "Film & Entertainment": [
    "Copy of the policy and production schedule",
    "FIR (in case of theft or third-party damage)",
    "Photographs / video of damaged equipment, sets or location",
    "Call sheets, contracts and the crew/cast list",
    "Medical or death records (for cast-related claims)",
    "Repair estimates and equipment rental invoices",
  ],
  "Other / Not sure": [
    "Copy of the policy",
    "Photographs related to the loss",
    "Any notices, FIR or reports available",
    "Estimates or bills related to the loss",
    "Your contact details for the surveyor visit",
  ],
};
